<div id="app-settings" role="tabpanel" class="tab-pane fade show active">
    <div class="announcement-inner">
        <div class="announcement-inner-header">
            <a href="javascript:void(0);" class="new-alert">{{NotificationDetail['TotalUnreadRecords']}} {{bs.getResource('rbkey_UnRdNtfctnLBL')}} </a>
            <div class="right-head">
                <div class="btn-group">
                    <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">
                        {{NotificationOrderBy}}
                        <!-- <span class="caret"></span> -->
                    </a>


                    <ul role="menu" class="dropdown-menu animated fadeIn right">
                        <li *ngFor="let sortItem of NotificationOrderByList">
                            <a href="javascript:void(0);" (click)="orderBy(sortItem)"style="display: block;">{{sortItem.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="announcement-tab-list">
            <div *ngFor="let item of TodayNotificationItems; let i = index" [attr.data-index]="i">
                <div id="notificationDiv{{item['NotificationId']}}" [ngClass]="setTodayClassName(i)">
                    <div class="atl-box-top">
                        <div class="atl-left-image">
                            <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_ItmNtfctnTdyThmbNlLBL')}}" *ngIf="item['Thumbnail']!=''">
                            <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_ItmNtfctnTdyHrnlLBL')}}" *ngIf="item['Thumbnail']==''">

                        </div>
                        <div class="atl-right-block">
                            <div class="atlr-top-name">
                                <a href="javascript:void(0);" (click)="routeNotificationItem(item)" [innerHTML]="item['NotificationBody']"></a>
                            </div>
                            <div class="atlr-top-date">{{item['ReceiveDate']}}</div>
                            <div class="atl-right-position">
                                <div class="atl-right-inner">
                                    <a href="javascript:void(0);" class="book-icon-right-pad" (click)="updateNotification(item['NotificationId'],0,'TODAY')"></a>
                                    <a href="javascript:void(0);" class="trash-icon" (click)="updateNotification(item['NotificationId'],1,'TODAY')"></a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="day-section" *ngIf="YesterdayNotificationItems.length > 0">
                <span class="day">{{bs.getResource('rbkey_YstrdyLBL')}}</span>
                <div class="border-bottom"></div>
            </div>
            <div *ngFor="let item of YesterdayNotificationItems; let j = index" [attr.data-index]="j">
                <div id="notificationDiv{{item['NotificationId']}}" [ngClass]="setYesterdayClassName(j)">
                    <div class="atl-box-top">
                        <div class="atl-left-image">
                            <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_ItmNtfctnYstrdyThmbNlLBL')}}" *ngIf="item['Thumbnail']!=''">
                            <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_ItmNtfctnYstrdyHrnlLBL')}}" *ngIf="item['Thumbnail']==''">

                        </div>
                        <div class="atl-right-block">
                            <div class="atlr-top-name">
                                <a href="javascript:void(0);" (click)="routeNotificationItem(item)" [innerHTML]="item['NotificationBody']"></a>

                            </div>
                            <div class="atlr-top-date">{{item['ReceiveDate']}}</div>
                            <div class="atl-right-position">
                                <div class="atl-right-inner">
                                    <a href="javascript:void(0);" class="book-icon-right-pad" (click)="updateNotification(item['NotificationId'],0,'YEST')"></a>
                                    <a href="javascript:void(0);" class="trash-icon" (click)="updateNotification(item['NotificationId'],1,'YEST')"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="day-section" *ngIf="OldNotificationItems.length > 0">
                <span class="day">{{bs.getResource('rbkey_OldrLBL')}}</span>
                <div class="border-bottom"></div>
            </div>
            <div *ngFor="let item of OldNotificationItems; let k = index" [attr.data-index]="k">
                <div id="notificationDiv{{item['NotificationId']}}" [ngClass]="setOldClassName(k)">
                    <div class="atl-box-top">
                        <div class="atl-left-image">
                            <img src="{{item['Thumbnail']}}" alt="{{bs.getResource('rbkey_ItmNtfctnOldThmbNlLBL')}}" *ngIf="item['Thumbnail']!=''">
                            <img src="assets/img/horn-image.jpg" alt="{{bs.getResource('rbkey_ItmNtfctnOldHrnlLBL')}}" *ngIf="item['Thumbnail']==''">

                        </div>
                        <div class="atl-right-block">
                            <div class="atlr-top-name">
                                <a href="javascript:void(0);" (click)="routeNotificationItem(item)" [innerHTML]="item['NotificationBody']"></a>

                            </div>
                            <div class="atlr-top-date">{{item['ReceiveDate']}}</div>
                            <div class="atl-right-position">
                                <div class="atl-right-inner">
                                    <a href="javascript:void(0);" class="book-icon-right-pad" (click)="updateNotification(item['NotificationId'],0,'OLD')"></a>
                                    <a href="javascript:void(0);" class="trash-icon" (click)="updateNotification(item['NotificationId'],1,'OLD')"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="announcement-tab-list" *ngIf="NotificationItems.length==0"><span class="noMoreRecord">{{bs.getResource('rbkey_No_Itm_Dsply')}}</span></div>
        <div class="announcement-inner-header" *ngIf="NotificationDetail['TotalRecords'] > 10">
            <div class="left-head">
                <a href="javascript:void(0);" (click)="navigateListPage()" class="mark-read-btn">{{bs.getResource('rbkey_VwMrLBL')}}</a>
            </div>
        </div>
    </div>
</div>